class PriceDisplay extends HTMLElement {
  constructor() {
    super();
    // Attach shadow DOM
    // this.attachShadow({ mode: "open" });
  }

  getData() {
    const data = document.querySelector("script[data-theme-discount-settings]");
    if (!data) return;
    const json = JSON.parse(data.innerHTML);
    this.data = json;
  }

  connectedCallback() {
    this.getData();
    this.render();
  }

  disconnectedCallback() {
    // Called when element is removed from the DOM
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // Called when an observed attribute changes
    // console.log("[PriceDisplay] Attribute changed", name, oldValue, newValue);
    if (oldValue !== newValue) {
      this.render();
    }
  }

  static get observedAttributes() {
    // Specify which attributes to observe
    return ["data-price", "data-compare-price"];
  }

  get comparePriceElement() {
    return this.querySelector("[data-compare-price]");
  }

  get priceElement() {
    return this.querySelector("[data-price]");
  }

  get instanceData() {
    const { price, comparePrice, tags, collections, handle } = this.dataset;
    return {
      price: Number(price),
      comparePrice: comparePrice === "" ? null : Number(comparePrice),
      tags: tags.split(","),
      collections: collections.split(","),
      handle,
    };
  }

  get applicableDiscount() {
    const { tags, collections, handle } = this.instanceData;
    const discount = this.data.find((discount) => {
      return (
        discount.tags.some((tag) => tags.includes(tag)) ||
        (discount.collection && collections.includes(discount.collection)) ||
        discount.products.some((product) => product === handle)
      );
    });

    return discount;
  }

  show() {
    this.style.visibility = "visible";
  }

  render() {
    if (!this.data) return;
    const applicableDiscount = this.applicableDiscount;

    // console.log(
    //   "Render Price display",
    //   this,
    //   applicableDiscount,
    //   this.priceElement
    // );

    if (!applicableDiscount) return this.show();

    const productData = this.instanceData;
    const discount = applicableDiscount.discount;
    const compareAtPrice =
      productData.comparePrice && productData.comparePrice > productData.price
        ? productData.comparePrice
        : productData.price;

    const price = productData.price * (1 - discount / 100);

    this.comparePriceElement.textContent =
      window.themeVendor.themeCurrency.formatMoney(
        compareAtPrice,
        window.theme.moneyFormat
      );

    // console.log(
    //   "[PriceDisplay] Price",
    //   this.priceElement,
    //   price,
    //   compareAtPrice
    // );
    this.priceElement.textContent =
      window.themeVendor.themeCurrency.formatMoney(
        price,
        window.theme.moneyFormat
      );
    this.priceElement.classList.add(...this.dataset.priceSaleClass.split(" "));

    this.comparePriceElement.style.display = "block";
    this.priceElement.style.display = "block";
    this.show();
  }
}

// Register the custom element
customElements.define("price-display", PriceDisplay);
